import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const LogoWrapper = styled.div`
  width: 100%;
  padding: 20px 15px;
  display: flex;
  align-items: center;

  > a {
    width: 100%;
    text-decoration: none;
    color: #fff;
    display: flex;
    align-items: center;

    > div {
      position: absolute;
      width: 50px;
      height: 50px;
      border-radius: 10px;
      overflow: hidden;
      margin: 10px 5px 10px 0;
      cursor: pointer;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.85; /* Transparent effect */
      }
    }

    > h4 {
      margin-left: 60px;
      color: #000000;
      font-size: 20px;
    }
  }
`;

const Logo = () => {
  return (
    <LogoWrapper>
      <Link>
        <div>
          <img src="/tcclogo.jpg" alt="TCC Logo" />
        </div>
        <h4>The Chennai Computers</h4>
      </Link>
    </LogoWrapper>
  );
};

export default Logo;
